import React from 'react';
import { FadeIn } from './FadeIn';
import { TestimonialCard } from './TestimonialCard';
export function Testimonials() {
  const testimonials = [{
    quote: 'Organicé todo mi año de aquagym en una tarde. Tengo cada clase pensada y secuenciada para todos mis grupos. Nunca más el domingo de pánico.',
    initials: 'VM',
    name: 'Valeria M.',
    location: 'Buenos Aires',
    role: 'INSTRUCTORA DE AQUAGYM EN NATATORIO',
    colorClass: 'bg-aqua-600'
  }, {
    quote: 'Las progresiones por nivel cambiaron todo. Mis alumnas avanzaron más en 2 meses que en todo el año anterior. Y dejaron de abandonar.',
    initials: 'CR',
    name: 'Carolina R.',
    location: 'Rosario',
    role: 'PROFE DE AQUAGYM EN GIMNASIO CON PILETA',
    colorClass: 'bg-deepblue-600'
  }, {
    quote: 'Adapto el mismo ejercicio a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo mezclado.',
    initials: 'SF',
    name: 'Sofía F.',
    location: 'Córdoba',
    role: 'INSTRUCTORA DE AQUAGYM GRUPAL E INDIVIDUAL',
    colorClass: 'bg-aqua-500'
  }];
  return <section className="py-8 md:py-20 bg-white" data-id="element-366">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-367">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-368">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-369">
              <TestimonialCard {...t} data-id="element-370" />
            </FadeIn>)}
        </div>
      </div>
    </section>;
}